import { LEADS_CRM_EXPORT_SELECTION_TOP_N_VALUES } from "app/pages/sales-intelligence/sub-modules/company-search/constants/websites-table";
import createExportSelectionDropdown from "app/pages/sales-intelligence/sub-modules/company-search/models/table-actions-panel/export/factory";
import type SelectionDropdownFactory from "app/pages/sales-intelligence/sub-modules/table-actions-panel/models/selection-dropdown/SelectionDropdownFactory";

const createCRMLeadsSelectionDropdown: SelectionDropdownFactory = createExportSelectionDropdown({
    fixedLimit: 1_000,
    topNValues: LEADS_CRM_EXPORT_SELECTION_TOP_N_VALUES,
});

export default createCRMLeadsSelectionDropdown;
